<header class="bg-white shadow-sm border-b border-gray-100 z-20 shrink-0 relative">
    <div class="max-w-7xl mx-auto px-4 h-auto sm:h-16 flex flex-wrap sm:flex-nowrap items-center justify-between gap-4 py-5 sm:py-0">

        <!-- LEFT: Title -->
        <div class="flex items-center gap-3 shrink-0 basis-auto order-1">
<!--            @if (navigateService.page()>1 && navigateService.pageTitle()!=='home'){-->
            @if (navigateService.pageTitle()!=='home' && !(navigateService.pageTitle()=='pagamento_ordine' && cartService.shipaddressConfirmed()) && navigateService.pageTitle()!=='success'){
                <button (click)="navigateService.goBack()" class="p-2 -ml-2 text-gray-600 hover:bg-gray-100 rounded-full transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                </button>
            }
            <div class="flex flex-col">
                <h1 class="font-bold text-xl text-primary tracking-wide leading-none hidden sm:block">{{ sessionService.currentUser()?.defaultcompany?.name??"nomeazienda"|translate }}</h1>
                @if (navigateService.pageTitle()==='home' && navigateService.searchQuery()==='') {
                    <span  class="text-[10px] uppercase tracking-widest text-gray-500 hidden sm:block">Self Order</span>
                }
            </div>
        </div>

        <!-- CENTER: Search Bar -->
    @if (navigateService.pageTitle()=='home' ) { <!--|| navigateService.pageTitle()=='detail' || navigateService.pageTitle()=='cart')-->
       <!--Disabled search bar past checkout phase-->
        <div class="flex-1 max-w-md mx-auto basis-full sm:basis-auto order-3 sm:order-2">
            <div class="relative group">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400 group-focus-within:text-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
                </div>
                <input type="text"
                       [placeholder]="'searchPlaceholder' | translate"
                       [value]="navigateService.searchQuery()"
                       (input)="onFilterChange($event)"
                       class="w-full bg-gray-100 border-none rounded-full py-2.5 pl-10 pr-4 text-sm focus:ring-2 focus:ring-primary/20 focus:bg-white transition-all outline-none placeholder:text-gray-400 text-gray-800 font-medium"
                >
                @if (navigateService.searchQuery()!==''){
                    <button (click)="navigateService.clearSearch()" class="absolute inset-y-0 right-0 pr-2 flex items-center text-gray-400 hover:text-gray-600">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                }
            </div>
        </div>
    }

        <!-- RIGHT: Controls -->
        <div class="flex justify-end sm:justify-center items-center gap-1 shrink-0 basis-auto  order-2 sm:order-3">

<!--            se utente abilitato, mostro il bottone per il cambio di paese di destinazione-->
            @if (sessionService.requiresDestinationCountry()){
                <!-- Change Destination Country (Tracking) -->
                @if (navigateService.pageTitle()==='home'){
                    @if(sessionService.IsRequiredShipment()){
                        <button (click)="openCountryDialog()"
                                class=" md:flex items-center justify-center p-2 rounded-full text-gray-500 hover:text-primary hover:bg-gray-100 transition-colors"
                                [title]="'changeCountry'|translate">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                 aria-hidden="true">
                                <circle cx="12" cy="12" r="10"></circle>
                                <circle cx="12" cy="12" r="2"></circle>
                                <line x1="12" y1="2" x2="12" y2="6"></line>
                                <line x1="12" y1="18" x2="12" y2="22"></line>
                                <line x1="2" y1="12" x2="6" y2="12"></line>
                                <line x1="18" y1="12" x2="22" y2="12"></line>
                            </svg>
                        </button>
                        <span class="md:flex items-center gap-1 text-xs font-semibold text-gray-500 select-none">
                            {{ 'destinationShort' | translate }}
                            <span class="font-bold text-gray-700">
                                {{ sessionService.CurrentCountry()?.iso_code ?? '-' }}
                            </span>
                        </span>
                    }
                    @else {
                        <span class="md:flex items-center gap-1 text-xs font-semibold text-gray-500 select-none">
                            {{ 'destinationsede' | translate }}
                            <span class="font-bold text-gray-700">
                                {{ sessionService.CurrentCountry()?.iso_code ?? '-' }}
                            </span>
                        </span>
                    }
            }
            }

            <!-- Reset (New Order) - Clears Data but stays on Home -->
            <button (click)="resetApp()" class="md:flex items-center gap-2 text-gray-500 hover:text-primary px-3 py-1.5 rounded-lg transition-colors font-medium text-sm" [title]="'newOrder'|translate">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
                <span class="hidden md:block">{{'newOrder'|translate }}</span>
            </button>

            <!-- Logout (Icon Only) - Goes to Login -->
            <button (click)="sessionService.logout()" class="flex items-center justify-center p-2 rounded-full text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors" [title]="'logout'|translate">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg>
            </button>

            <div class="h-6 w-px bg-gray-200 hidden sm:block mx-1"></div>

            @if (navigateService.pageTitle()==='home'){
              <!-- Lang -->
              <app-language-selector></app-language-selector>
           }
            <!-- Cart -->   
        @if (navigateService.pageTitle()!='success'){   <!--Disable cart icon in success page-->
            <button (click)="navigateToCart()" class="relative p-2 ml-1 text-gray-600 hover:text-primary transition-colors group">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>
                @if (cartCount()>0){
                  <span class="absolute -top-1 -right-1 bg-primary text-white text-[10px] font-bold rounded-full h-5 w-5 flex items-center justify-center shadow-sm border-2 border-white animate-bounce-short">
                   {{ cartCount() }}
                  </span>
                }
            </button>
        }
        </div>
    </div>
</header>